import { useTranslation } from "react-i18next";

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    // Add RTL support for Arabic
    document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
    document.documentElement.lang = lng;

    // Update stored preference when manually changed
    localStorage.setItem("apcg2026-preferred-language", lng);
    localStorage.setItem("apcg2026-language-selected", "true");
  };

  return (
    <div className="language-selector px-2" style={{ minWidth: "100px" }}>
      <div className="btn-group language-buttons">
        <button
          className={`btn btn-sm btn-link text-dark text-md-white px-1 ${
            i18n.language === "en" ? "fw-bold" : ""
          }`}
          style={{ fontWeight: "bold !important" }}
          onClick={() => changeLanguage("en")}
        >
          EN
        </button>
        <span className="text-dark text-md-white px-1">|</span>
        <button
          className={`btn btn-sm btn-link text-dark text-md-white px-1 ${
            i18n.language === "ar" ? "fw-bold" : ""
          }`}
          style={{ fontWeight: "bold !important" }}
          onClick={() => changeLanguage("ar")}
        >
          العربية
        </button>
      </div>
    </div>
  );
};

export default LanguageSelector;
